// @flow

import { conformToMask } from 'text-mask-core';
import { type Mask } from './types';

export function formatValueWithMask(rawValue: string, mask: Mask): string {
  return conformToMask(rawValue, mask, {guide: false}).conformedValue;
}
